<template>
  <div id="main">
      <!-- <div class="api_link">
          <span></span>
      </div> -->
      <div class="details_title select_flow_title">{{ $t("selectFlow.Title") }}</div>
      <div class="flow-box">
          <ul>
              <li class="flow_list" @click="selectFlow('WITH_LABEL')">
                <div>
                  <p>{{ $t("selectFlow.WithLabelTitle") }}</p>
                  <p class="flow_list_subtitle">{{ $t("selectFlow.WithLabelSubTitle") }}</p>
                </div>
              </li>
              <li class="flow_list" @click="selectFlow('WITHOUT_LABEL')">
                <div>
                  <p>{{ $t("selectFlow.WithoutLabelTitle") }}</p>
                  <p class="flow_list_subtitle">{{ $t("selectFlow.WithoutLabelSubTitle") }}</p>
                </div>
              </li>
          </ul>
      </div>
      <bottom></bottom>
      <button class="details_bt_w" @click="back()">{{$t('common.Back')}}</button>
  </div>
</template>

<script>
import logo from '../assets/image/common/ExpiredLogo.png'
import bottom from './Bottom.vue'
export default {
  name: 'SelectFlow',
  components: {bottom},
  data () {
    return {
      title: null,
      companyList: [],
      action: null,
      allowAction: {'merchantTakeExpress': true, 'collectExpiredExpress': true, 'select': true}
    }
  },
  beforeCreate: function () {
    document.getElementsByTagName('body')[0].style = 'background-color: #f8f8f8;'
    // 获取操作
    this.action = this.$route.query.action
    let action = this.action
    // 判断是否是允许的操作
    let res = this.actionList
    if (!res[action]) {
      alert('Unknown operation')
      // 未知的操作直接返回
      this.$router.push('/index')
      return false
    }
  },
  created () {
  },
  methods: {
    back () {
      this.$router.go(-1)
    },
    selectFlow (flow) {
      if(flow === 'WITHOUT_LABEL'){
        this.$router.push(`/barcodeWithoutLabel?flow=${flow}&step=1&action=collectingPointStoreExpress&next=true`)
      }
      else {
        this.$router.push(`/barcode?flow=${flow}&step=1&action=collectingPointStoreExpress&next=true`)
      }
      
    }
  }
}
</script>
<style scoped>
.details_bt_w{
    /* position: fixed; */
    position: sticky;
    width: 83%;
    bottom: 0.38rem;
}
.flow-box{
    /* min-height: calc(70vh); */
}

.bottom{
    /*position: relative;*/
    /*bottom: 0;*/
}

.select_flow_title{
  color: var(--primary-text-color);
  margin-top: 80px  !important;
  margin-bottom: 100px  !important;
}

@media (max-height: 820px) {
  .select_flow_title{
    margin-top: 50px !important;
    margin-bottom: 50px !important;
  }
}

@media (max-height: 720px) {
  .select_flow_title{
    margin-top: 30px !important;
    margin-bottom: 30px !important;
  }
}

.api_link{
  width: 100%;
  height: 25.3%;
}
.api_link span{
    color: #FF0000;
    font-size:0.145rem;
    font-weight:400;
    font-family: 'Poppins-Regular';
    line-height:0.17rem;
    margin: 0.81rem 10%;
    display:inline-block;
}
.details_title {
    width: 92%;
    margin:0 4%;
    min-height: 0.5rem;
    /* color: #1f8dc5; */
    /* color: #01BAFF; */
    /* color: var(--primary-color); */
    /*font-weight: bold;*/
    font-family: Poppins-Bold;
    font-size:0.35rem;
    line-height:0.415rem;
}
.select_company {
    width: 92%;
    margin:0.17rem 4%;
    height:0.235rem;
    font-size:0.2rem;
    color: #1f8dc5;
    /*font-weight: bold;*/
    font-family: Poppins-Bold;
    line-height:0.235rem;
}
.flow_list{
    width: 93%;
    min-height:1.08rem;
    background:rgba(255,255,255,1);
    box-shadow:0rem 0.025rem 0.05rem rgba(0,0,0,0.3);
    border-radius:0.1rem;
    margin: 0.1rem 3.5%;
    display: flex;
    align-items: center;
}
.flow_list p{
    /*margin:0.355rem 0.01rem;*/
    font-size:0.2rem;
    /*font-weight:bold;*/
    font-family: Poppins-Bold;
    line-height:0.35rem;
    color:#0055FF;
    margin-left: 0.15rem;
    overflow: hidden;
    display: flex;
    align-items: center;
    margin-top: 10px;
    margin-bottom: 10px;
}
.flow_list .flow_list_subtitle{
    font-size:0.15rem;
    font-family: Rubik;
    font-weight: 400;
    font-style: Regular;
    /*font-size: 30px;*/
    leading-trim: NONE;
    line-height: 100%;
    letter-spacing: 0%;
    color: var(--primary-label-color);
    white-space: pre-wrap;
}
.details_bt_w {
  width: 82%;
  height:0.58rem;
  /* background: rgba(255, 255, 255, 1); */
  background: var(--primary-inverted-button-bg-color);
  box-shadow:0rem 0.05rem 0.1rem rgba(0,0,0,0.16);
  opacity: 1;
  border-radius:0.42rem;
  margin: 0.145rem 9% 0;
  border: none;
  /* color: rgba(5, 36, 96, 1); */
  color: var(--primary-inverted-button-text-color);
  line-height:0.235rem;
  font-size:0.2rem;
  /*font-weight: bold;*/
    font-family: Poppins-Bold;
}

</style>



// WEBPACK FOOTER //
// src/components/SelectFlow.vue